import request from '@/utils/request'

export function fetchMyInfo(query) {
  return request({
    url: '/my/info',
    params: query
  })
}

export function fetchMyLimit() {
  return request({
    url: '/my/limit'
  })
}

export function fetchMyFavTopicList() {
  return request({
    url: '/my/topic/list/fav'
  })
}

export function updateMyInfo(item) {
  return request({
    url: '/my/info',
    method: 'put',
    data: item
  })
}

export function uploadImage(file) {
  const fileData = new FormData()
  fileData.append('img', file)
  return request({
    url: '/upload/',
    method: 'post',
    data: fileData
  })
}

export function uploadExpoImage(file) {
  const fileData = new FormData()
  fileData.append('img', file)
  return request({
    url: '/upload/expo',
    method: 'post',
    data: fileData
  })
}

export function uploadAvatar(file) {
  const fileData = new FormData()
  fileData.append('img', file)
  return request({
    url: '/upload/avatar',
    method: 'post',
    data: fileData
  })
}

export function updateMyAvatar(url) {
  return request({
    url: '/my/info/avatar',
    method: 'put',
    data: { avatar: url }
  })
}

export function updateMyMobile(item) {
  return request({
    url: '/my/info/mobile',
    method: 'put',
    data: item
  })
}

export function saveSign() {
  return request({
    url: '/my/sign',
    method: 'post'
  })
}

export function fetchMyCoinLog(query) {
  return request({
    url: '/my/coin/log',
    method: 'get',
    params: query
  })
}

export function fetchMyMsg(query) {
  return request({
    url: '/my/msg',
    method: 'get',
    params: query
  })
}

export function fetchMySetting() {
  return request({
    url: '/my/setting',
    method: 'get'
  })
}

export function updateMySetting(item) {
  return request({
    url: '/my/setting',
    method: 'put',
    data: item
  })
}

export function fetchMyOrderMeetingList(query) {
  return request({
    url: '/order/m/list',
    method: 'get',
    params: query
  })
}

export function fetchMyOrderVipList(query) {
  return request({
    url: '/order/vip/list',
    method: 'get',
    params: query
  })
}

export function fetchMyOrderContactsList(query) {
  return request({
    url: '/order/contacts/list',
    method: 'get',
    params: query
  })
}

export function fetchMyOrderCardList(query) {
  return request({
    url: '/order/card/list',
    method: 'get',
    params: query
  })
}

export function fetchMyOrderVideoList(query) {
  return request({
    url: '/order/video/list',
    method: 'get',
    params: query
  })
}

export function unbindMyWechat() {
  return request({
    url: '/my/wx/unbind',
    method: 'put'
  })
}

export function noticeMySubscribe() {
  return request({
    url: '/my/subscribe/notice',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/my.js